import React from "react";
//import PropTypes from "prop-types";
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { getTranslate } from "react-localize-redux";
import { postReceiverLocation, getReceiverLocations, deleteReceiverLocation, putReceiverLocation } from '../../actions/location'


// material-ui components
import withStyles from "material-ui/styles/withStyles";

import SweetAlert from "react-bootstrap-sweetalert";



// core components
import IconCard from "components/Cards/IconCard.jsx";
import RequirementsCard from "components/Cards/RequirementsCard.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import ItemGrid from "components/Grid/ItemGrid.jsx";
import Table from "components/Table/Table.jsx";
import Button from "components/CustomButtons/Button.jsx";

import SimpleForm from "components/SimpleForm/SimpleForm.jsx";

import Wizard from "components/Wizard/Wizard.jsx";

import Step1 from "./AddLocationWizardSteps/Step1.jsx";
import Step2 from "./AddLocationWizardSteps/Step2.jsx";
import Step3 from "./AddLocationWizardSteps/Step3.jsx";

import { locationFields } from "variables/variables.jsx";


import LocationsMap from "components/LocationsMap/LocationsMap.jsx";


// material-ui icons
import Assignment from "@material-ui/icons/Assignment";
import Person from "@material-ui/icons/Person";
import Edit from "@material-ui/icons/Edit";
import Close from "@material-ui/icons/Close";
import AddLocation from "@material-ui/icons/AddLocation";

import locationsPageStyle from "assets/jss/material-dashboard-pro-react/views/locationsPageStyle.jsx";


class Locations extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      locations: [],
      alert: null,
      add: {},
      edit: {},
      wizardId: Date.now(),
    };
    this.handleLocationAddChange = this.handleLocationAddChange.bind(this);
    this.handleLocationAddSubmit = this.handleLocationAddSubmit.bind(this);
    this.handleLocationEditSubmit = this.handleLocationEditSubmit.bind(this);
    this.handleLocationEditChange = this.handleLocationEditChange.bind(this);
    this.handleLocationEditCancel = this.handleLocationEditCancel.bind(this);
  }

  handleLocationEditSubmit(){
    this.props.dispatchPutLocation(this.props.auth.user, this.state.edit)
    .then( res => {
      return this.props.dispatchGetLocations(this.props.auth.user);
    })
    .then( locations => {
      this.setState({edit:{}});
      this.setState({locations});
      this.setState({
        alert: (
          <SweetAlert
            success
            style={{ display: "block", marginTop: "-100px" }}
            title="Good job!"
            onConfirm={() => this.hideAlert()}
            onCancel={() => this.hideAlert()}
            confirmBtnCssClass={
              this.props.classes.button + " " + this.props.classes.success
            }
          >
            You clicked the button!
          </SweetAlert>
        )
      });
    });

  }  

  handleLocationEditChange(e, stateName, type, stateNameEqualTo){
    let value = e.target.value;
    if(e.target.type==="checkbox"){
      value = e.target.checked;
    }
    this.setState({edit:{ ...this.state.edit, [e.target.name]: value }});
    
  }

  handleLocationEditCancel(){
      this.setState({edit:{}});    
  }



  handleLocationAddSubmit(){
    this.props.dispatchPostLocation(this.props.auth.user, this.state.add)
    .then( res => {
      return this.props.dispatchGetLocations(this.props.auth.user);
    })
    .then( locations => {
      this.setState({wizardId: Date.now()});
      this.setState({locations});
      this.setState({
        alert: (
          <SweetAlert
            success
            style={{ display: "block", marginTop: "-100px" }}
            title="Good job!"
            onConfirm={() => this.hideAlert()}
            onCancel={() => this.hideAlert()}
            confirmBtnCssClass={
              this.props.classes.button + " " + this.props.classes.success
            }
          >
            You clicked the button!
          </SweetAlert>
        )
      });
    });    

  }


  handleLocationAddChange(state){

    //if(typeof available !== "undefined") this.setState({add:{available}});

    this.setState({add:{...this.state.add, ...state}});
    
  }

  handleConfirmDelete(id){
    this.props.dispatchDeleteLocation(this.props.auth.user, {id} )
    .then( res => {
      return this.props.dispatchGetLocations(this.props.auth.user);
    })
    .then( locations => {
      this.setState({locations});
      this.hideAlert();
    });
  }

  handleTableAction(action, id){
    if(action==="delete"){
      this.setState({
        alert: (
          <SweetAlert
            warning
            style={{ display: "block", marginTop: "-100px" }}
            title="Are you sure?"
            onConfirm={() => this.handleConfirmDelete(id)}
            onCancel={() => this.hideAlert()}
            confirmBtnCssClass={
              this.props.classes.button + " " + this.props.classes.success
            }
            cancelBtnCssClass={
              this.props.classes.button + " " + this.props.classes.danger
            }
            confirmBtnText="Yes, delete it!"
            cancelBtnText="Cancel"
            showCancel
          >
            You will not be able to recover this imaginary file!
          </SweetAlert>
        )
      });  
    }  
    if(action==="edit"){
      var item = this.state.locations.find(function(i) {
        return i.id === id;
      });
      item.available = (item.available===1)?true:false;
      this.setState({editId: Date.now()});

      this.setState({edit:item});
    }
  }
  hideAlert() {
    this.setState({
      alert: null
    });
  }

  componentDidMount() {
    this.props.dispatchGetLocations(this.props.auth.user)
    .then( locations => {
      this.setState({locations});

    });   
  }
  render() {
    const {  translate, classes } = this.props;

    var locationTableData = [];
    if(this.state.locations.length>0){
      this.state.locations.map((prop,key)=>{
        
        let fillButtons = [
          { color: "info", icon: Person, action:"view" },
          { color: "success", icon: Edit, action: "edit" },
          { color: "danger", icon: Close, action: "delete" }
        ].map((button, buttonKey) => {
          return (
            <Button color={button.color} customClass={classes.actionButton} onClick={() => this.handleTableAction(button.action, prop.id)} key={buttonKey}>
              <button.icon className={classes.icon} />
            </Button>
          );
        });
        locationTableData.push([prop.id, prop.nickname, prop.available?"Yes":"No", fillButtons]);
        return false;
      });
    }
    
    return (
      <div>
        <GridContainer>
          {this.state.alert}
          <SimpleForm 
            fields={[...locationFields.step3,...locationFields.step1,...locationFields.step2]}
            onChange={this.handleLocationEditChange} 
            editId={this.state.editId} 
            state={this.state.edit} 
            open={this.state.edit.id?true:false}
            classes={classes}
            onSubmit={this.handleLocationEditSubmit}
            onCancel={this.handleLocationEditCancel}
          />
          <ItemGrid xs={12} sm={12} md={6}>
            <RequirementsCard content={translate("requirements.receiver_locations.content")} />
          </ItemGrid>
          <ItemGrid xs={12} sm={12} md={6}>
            <Wizard
              key={this.state.wizardId}
              validate
              steps={[
                { stepName: "About", stepComponent: Step1, stepId: "about" },
                { stepName: "Address", stepComponent: Step2, stepId: "address" },
                { stepName: "Schedule", stepComponent: Step3, stepId: "account" },
              ]}
              title="Add a location"
              subtitle="This information will let us know more about you."
              finishButtonClick={this.handleLocationAddSubmit}
              sendState={this.handleLocationAddChange}
            />
          </ItemGrid>                    
          <ItemGrid xs={12} sm={12} md={6}>
            <IconCard
              icon={Assignment}
              iconColor="rose"
              title="My Locations"
              content={
                <Table
                  tableHead={[
                    "#",
                    "Nickname",
                    "Available",
                    "Actions"
                  ]}
                  tableData={locationTableData}
                />
              }
            />
          </ItemGrid>        
          <ItemGrid xs={12} sm={12} md={6}>
            <IconCard
              title="Regular Map"
              iconColor="rose"
              icon={AddLocation}
              content={<LocationsMap locations={this.state.locations} />}
            />
          </ItemGrid>            
        </GridContainer>
      </div>
    );
  }
}


const mapDispatchToProps = {
  dispatchPostLocation: (user, data) => postReceiverLocation(user, data),
  dispatchPutLocation: (user, data) => putReceiverLocation(user, data),
  dispatchGetLocations: (user) => getReceiverLocations(user),
  dispatchDeleteLocation: (user, data) => deleteReceiverLocation(user, data),
}

const mapStateToProps = (state, props) => {
  return {
    translate: getTranslate(state.localize),
    auth: state.auth,
    userDetails: state.user.userDetails,
    userRoles: state.user.roles,
  }
}


export default compose(
  withStyles(locationsPageStyle),
  connect(mapStateToProps, mapDispatchToProps)
)(Locations);




// WEBPACK FOOTER //
// ./src/views/Receiver/Locations.jsx